/**
 * The one hop between "a push arrived" and "the pill shows it".
 *
 * A two-line event bus rather than a React context, because the only two
 * parties are `PushBridge` (which hands `showPill` to `initPush`) and the pill
 * itself, and they are siblings mounted side by side in App.js. A context
 * would mean a provider wrapping the whole tree to carry one callback.
 *
 * A push that arrives with no pill mounted is DROPPED, on purpose: the pill
 * only ever shows while the app is in front, and the service worker shows a
 * system notification in every other case.
 */
let listener = null;

export const onPill = (fn) => {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
};

export const showPill = (data) => {
  if (listener) listener(data);
};
